module.exports = __webpack_public_path__ + "img/xm.d0de9070.png";